import { render, staticRenderFns } from "./bill-list.vue?vue&type=template&id=62a68291&scoped=true&"
import script from "./bill-list.vue?vue&type=script&lang=js&"
export * from "./bill-list.vue?vue&type=script&lang=js&"
import style0 from "./bill.scss?vue&type=style&index=0&id=62a68291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a68291",
  null
  
)

export default component.exports